import { Card, CardContent, CardHeader, CardTitle } from "@frontend/components/ui/card"

export function AppInfo() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>About</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 text-sm">
          <dt className="text-muted-foreground">Version</dt>
          <dd>{__APP_VERSION__}</dd>
          <dt className="text-muted-foreground">Commit</dt>
          <dd className="font-mono">{__GIT_COMMIT__}</dd>
        </dl>
      </CardContent>
    </Card>
  )
}
